import {
    DEEP_MODIFY_ORDER_ITEM,
    DESTROY_CART,
    MODIFY_ORDER_ITEM,
    REPLACE_ORDER_ITEMS,
    RESET_ORDER,
    SET_ORDER_OPTIONS,
    START_BLINKER,
    SET_CURRENT_HOURS,
    START_ALERT_TIME,
    SET_TIME_LIMIT,
    SET_DEFAULT_PARAMS,
    RESET_TIMERS
} from '../mutations/order';

import moment from 'moment';
import {arrayToArrayOfGroups, getProductPrice} from '../../libraries/utils';

export const getInitialState = () => ({
    type: null,
    date: null,
    fine_fascia: null,
    items: [],
    total_items: 0,
    id_menu: -1,
    id_orario: -1,
    counter: 1,
    f_appena_possibile: false,
    n_persone: null,
    id_punto_di_servizio: null,
    type_default: null,
    id_punto_di_servizio_default: null,
    label_tipologia: null,
    table: null,
    address_default: null,

    blinker: null,
    blinker_idx: 0,
    blinker_keys: [],

    hours: [],
    timers: [],
    time_limit: null,
    id_locale: null,

    address: null
});

const order = {
    namespaced: true,
    state: getInitialState(),
    getters: {
        started: (state) => {
            return state.type && state.id_menu > 0;
        },
        optionsDescription: (state) => (language) => {
            let str;
            if (state.type === 'ORDINA_TAVOLO') {
                str = state.table.nome;
            } else {
                const date = moment(state.date).locale(language);
                str = date.format('dddd') + ' ' + date.format('D').padStart(2, '0') + ' - ' + date.format('HH:mm');

                if (state.fine_fascia) {
                    str += moment(state.fine_fascia, "HH:mm:ss").format("/HH:mm");
                }
            }

            return str;
        },
        totalProductsPriceForCoupon: (state) => {
            let total_price = 0;
            state.items.forEach((item) => {
                if(item.item.f_sconto){
                    total_price += (item.single_cost * item.quantity);
                }
            });

            return total_price;
        },
        totalProductsPrice: (state) => {
            let total_price = 0;
            state.items.forEach((item) => {
                total_price += (item.single_cost * item.quantity);
            });

            return total_price;
        },
        productsIds: (state) => {
            return state.items.map((item) => {
                return item.item.id
            })
        },
        suggestedProducts: (state) => {
            return state.items.filter((item) => {
                return item.prodotti_suggeriti && item.prodotti_suggeriti.length;
            }).reduce((suggested, item) => {
                return suggested.concat(item.prodotti_suggeriti);
            }, [])
        },
        getProductFreePicksGroup: (state) => (product_picks) => {
            return arrayToArrayOfGroups(product_picks.filter((pick) => pick), 'id');
        },
        cartMustBeReset: (state) => (room_id) => {
            if (state.total_items > 0) {
                return state.id_locale !== room_id;
            }

            return false;
        }
    },
    mutations: {
        [SET_ORDER_OPTIONS](state, payload) {
            Object.keys(payload.options).forEach((key) => {
                if (state.hasOwnProperty(key)) {
                    state[key] = payload.options[key];
                }
            });

            if (state.blinker) {
                clearInterval(state.blinker);
            }
        },
        [START_BLINKER](state) {
            state.blinker_keys = [0, 1];
            if (state.f_appena_possibile) {
                state.blinker_keys.push(2);
            }
            if (state.type === 'DELIVERY' && state.address && state.address.tipo === 'COORDINATE') {
                state.blinker_keys.push(3);
            }

            state.blinker = setInterval(() => {
                if (state.blinker_idx >= (state.blinker_keys.length - 1)) {
                    state.blinker_idx = 0;
                } else {
                    state.blinker_idx += 1;
                }
            }, 4000);
        },
        [MODIFY_ORDER_ITEM](state, payload) {
            state.counter = payload.counter;
            state.items = payload.items;
            state.total_items = payload.total_items;
        },
        [DESTROY_CART](state) {
            state.items = [];
            state.total_items = 0
        },
        [RESET_ORDER](state) {
            if (state.blinker) {
                clearInterval(state.blinker);
            }

            //resetto tutto tranne la roba per la fiera
            Object.assign(state, getInitialState(), {
                id_punto_di_servizio_default: state.id_punto_di_servizio_default,
                type_default: state.type_default,
                type: state.type_default,
                id_punto_di_servizio: state.id_punto_di_servizio_default,
                address_default: state.address_default,
                address: state.address_default
            });
        },
        [REPLACE_ORDER_ITEMS](state, payload) {
            let new_total_items = 0;
            payload.items.forEach(function (item) {
                new_total_items += item.quantity;
            });

            state.items = payload.items;
            state.total_items = new_total_items;
        },
        [DEEP_MODIFY_ORDER_ITEM](state, payload) {
            state.total_items = payload.total_items;
            state.items = payload.items;
        },
        [SET_CURRENT_HOURS](state, payload) {
            state.hours = payload.hours
        },
        [START_ALERT_TIME](state, payload) {
            state.timers.forEach((timer) => {
                clearTimeout(timer);
            });

            state.timers = payload.timers;
        },
        [SET_TIME_LIMIT](state, payload) {
            state.time_limit = payload.limit;
        },
        [SET_DEFAULT_PARAMS](state, payload) {
            state.id_punto_di_servizio = payload.id_punto_di_servizio_default;
            state.id_punto_di_servizio_default = payload.id_punto_di_servizio_default;
            state.type = payload.type_default;
            state.type_default = payload.type_default;
            state.address = payload.address_default;
            state.address_default = payload.address_default;
        },
        [RESET_TIMERS](state) {
            if (state.timers.length) {
                state.timers.forEach((timer) => {
                    clearTimeout(timer);
                });

                state.timers = [];
            }
        }
    },
    actions: {
        setOptions: function ({dispatch, commit, state}, options) {
            commit({
                type: SET_ORDER_OPTIONS,
                options
            });

            dispatch('startBlinker');
        },
        startBlinker: function ({commit, state}) {
            if (state.type && state.date) {
                commit({
                    type: START_BLINKER
                });
            }
        },
        modifyItem: function ({commit, state}, payload) {
            let updated = false;
            let total_items = state.total_items;
            let items = state.items;

            for (let i = 0; (!updated && i < items.length); i++) {
                if (JSON.stringify(payload.item) === JSON.stringify(items[i].item)) {
                    total_items += payload.quantity;
                    items[i].quantity += payload.quantity;
                    items[i].single_cost = getProductPrice(payload.item, state.type);
                    if (items[i].quantity === 0) {
                        items.splice(i, 1);
                    }
                    updated = true;
                }
            }
            if (!updated) {
                total_items += payload.quantity;
                items.push({
                    item: payload.item,
                    quantity: payload.quantity,
                    mobile_id: state.counter,
                    single_cost: getProductPrice(payload.item, state.type),
                    menu_presenti: payload.menu_presenti,
                    f_delivery: payload.f_delivery,
                    prodotti_suggeriti: payload.prodotti_suggeriti
                });
            }

            commit({
                type: MODIFY_ORDER_ITEM,
                items,
                total_items,
                counter: ++state.counter
            });
        },
        destroyCart: function ({commit}) {
            commit({
                type: DESTROY_CART
            });
        },
        reset: function ({commit, dispatch}) {
            dispatch('resetTimers');

            commit({
                type: RESET_ORDER
            });
        },
        replaceItems: function ({commit}, items) {
            commit({
                type: REPLACE_ORDER_ITEMS,
                items
            })
        },
        deepModifyItem: function ({commit, state}, payload) {
            let total_items = state.total_items;
            let items = state.items;

            for (let i = 0; (i < items.length); i++) {
                if (JSON.stringify(payload.initial_item) === JSON.stringify(items[i].item)) {
                    total_items -= items[i].quantity;
                    total_items += payload.quantity;
                    items[i].quantity = payload.quantity;
                    items[i].item.price = payload.price;
                    items[i].item.adds = payload.adds;
                    items[i].item.free_picks = payload.free_picks;
                    items[i].item.prodotto_composto_associati = payload.prodotto_composto_associati;
                    items[i].item.note = payload.note;
                    items[i].item.proportion = payload.proportion;
                    items[i].item.standard_proportion = payload.standard_proportion;
                    items[i].item.variant = payload.variant;
                    items[i].single_cost = getProductPrice(items[i].item, state.type);
                    if (items[i].quantity === 0) {
                        items.splice(i, 1);
                    } else {
                        for (let j = 0; j < items.length; j++) {
                            if (i !== j && JSON.stringify(items[i].item) === JSON.stringify(items[j].item)) {
                                items[j].quantity += items[i].quantity;
                                items.splice(i, 1);
                            }
                        }
                    }
                }
            }

            commit({
                type: DEEP_MODIFY_ORDER_ITEM,
                total_items,
                items
            });
        },
        setCurrentHours({commit}, hours) {
            commit({
                type: SET_CURRENT_HOURS,
                hours
            })
        },
        startAlertTime({commit, dispatch}, payload) {
            const timers = [];
            //la fine
            const start = moment();
            const end = moment(payload.end_date);
            timers.push(setTimeout(() => {
                dispatch('global/showModalCartExpired', {
                    show: true,
                    error: '',
                }, {root: true});
            }, end.diff(start, "milliseconds")));
            //2 minuti prima
            end.subtract(2, "minutes");
            if (end.isAfter(start)) {
                timers.push(setTimeout(() => {
                    dispatch('global/showModalCartTimer', {
                        show: true,
                        minutes: 2,
                    }, {root: true});
                }, end.diff(start, "milliseconds")));
            }
            //5 minuti prima
            end.subtract(3, "minutes");
            if (end.isAfter(start)) {
                timers.push(setTimeout(() => {
                    dispatch('global/showModalCartTimer', {
                        show: true,
                        minutes: 5,
                    }, {root: true});
                }, end.diff(start, "milliseconds")));
            }
            //10 minuti prima
            end.subtract(5, "minutes");
            if (end.isAfter(start)) {
                timers.push(setTimeout(() => {
                    dispatch('global/showModalCartTimer', {
                        show: true,
                        minutes: 10,
                    }, {root: true});
                }, end.diff(start, "milliseconds")));
            }

            commit({
                type: START_ALERT_TIME,
                timers
            })
        },
        setTimeLimit({commit, dispatch}, payload) {
            commit({
                type: SET_TIME_LIMIT,
                limit: payload.limit
            });

            dispatch('startAlertTime', {
                end_date: payload.limit
            });
        },
        setDefaultParams({commit}, payload) {
            commit({
                type: SET_DEFAULT_PARAMS,
                id_punto_di_servizio_default: payload.id_punto_di_servizio_default,
                type_default: payload.type_default,
                address_default: payload.address_default
            });
        },
        resetTimers({commit}) {
            commit({
                type: RESET_TIMERS
            });
        }
    }
};

export default order;
